const CONFIG = {
  BASE_URL: 'https://news-api-v1-2022.herokuapp.com/api/v1/post',
  DEFAULT_LANGUAGE: 'en-us',
  CACHE_NAME: 'PeduliLingkungan-V1',
};

export default CONFIG;
